import {
	animate,
	style,
	transition,
	trigger
} from '@angular/animations';

export const fadeInOut = [
	trigger( 'fadeInOut', [
		transition( ':enter', [
			style( { opacity: 0 } ),
			animate( '.3s .1s', style( { opacity: 1 } ) )
		] ),
		transition( ':leave', [
			animate( '.1s', style( { opacity: 0 } ) )
		] )
	] )
];

export const fadeIn = [
	trigger( 'fadeIn', [
		transition( ':enter', [
			style( { opacity: 0 } ),
			animate( '.3s 0s', style( { opacity: 1 } ) )
		] ),
		transition( ':leave', [
			animate( '0s', style( { opacity: 0 } ) )
		] )
	] )
];
